import Splide from '@splidejs/splide';

function initGallerySliders() {
    const sliders = document.querySelectorAll('.splide[data-gallery-slider]');
    if (!sliders.length) return;

    const isRTLDocument = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';

    sliders.forEach((slider) => {
        if (slider.dataset.initialized === 'true') return;

        const hasMultiple = slider.dataset.hasMultiple === 'true';
        const isRTL = slider.dataset.rtl === 'true' || isRTLDocument;

        const options = {
            type: hasMultiple ? 'loop' : 'slide',
            perPage: 1,
            rewind: true,
            autoplay: hasMultiple,
            interval: 4000,
            pauseOnHover: true,
            arrows: hasMultiple,
            pagination: hasMultiple,
            lazyLoad: false,
            direction: isRTL ? 'rtl' : 'ltr',
        };

        new Splide(slider, options).mount();
        slider.dataset.initialized = 'true';
    });
}

window.addEventListener('DOMContentLoaded', () => {
    initGallerySliders();
});
